import { create } from 'zustand';

export const useUserStore = create(set => ({
  mode: null,
  accessToken: null,
  accountType: null,
  setAccessToken: token => set({ accessToken: token }),
  setAccountType: type => set({ accountType: type }),
  setMode: mode => set({ mode }),
  clearTokens: () => set({ accessToken: null }),
}));
